import {
  locationSubmitPickupDeliveryAddressState,
  pickupLocationPickupDeliveryAddress
} from "./submitPickupDeliveryAddress";

export default {
  locationSubmitPickupDeliveryAddressState,
  pickupLocationPickupDeliveryAddress
};
